"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _axios = _interopRequireDefault(require("axios"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _clsx = _interopRequireDefault(require("clsx"));

var _formContext = _interopRequireDefault(require("./context/formContext"));

var _Form = _interopRequireDefault(require("./Form.styles"));

var _excluded = ["absoluteUrl", "authorization", "contentType", "method", "config", "onAfterSubmit", "onChange", "onSubmit"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Form = function Form(props) {
  var css = (0, _Form.default)();

  var absoluteUrl = props.absoluteUrl,
      authorization = props.authorization,
      _props$contentType = props.contentType,
      contentType = _props$contentType === void 0 ? "formData" : _props$contentType,
      _props$method = props.method,
      method = _props$method === void 0 ? "POST" : _props$method,
      config = props.config,
      onAfterSubmit = props.onAfterSubmit,
      _onChange = props.onChange,
      onSubmit = props.onSubmit,
      formProps = _objectWithoutProperties(props, _excluded);

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      formConfig = _useState2[0],
      setFormConfig = _useState2[1];

  var _useState3 = (0, _react.useState)({}),
      _useState4 = _slicedToArray(_useState3, 2),
      serverResponse = _useState4[0],
      setServerResponse = _useState4[1];

  var formRef = (0, _react.useRef)(null);
  var formSendDate = (0, _react.useRef)(null);
  var navigate = (0, _reactRouterDom.useNavigate)();
  var recaptchaRef = formConfig.recaptchaRef;
  (0, _react.useEffect)(function () {
    if (!(0, _isEmpty.default)(serverResponse)) {
      var sendCompleteDate = new Date();
      var differenceToOneSecond = 1000 - (sendCompleteDate.getTime() - formSendDate.current.getTime());
      var timer = differenceToOneSecond > 0 ? differenceToOneSecond : 0; // unlock form

      setTimeout(function () {
        setFormConfig(_objectSpread(_objectSpread({}, formConfig), {}, {
          formLocked: false,
          response: serverResponse
        }));
      }, timer);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [serverResponse]);

  var handleFormCheck = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var $form, tmpErrorObj;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              $form = e.target;
              tmpErrorObj = {};
              $form.querySelectorAll("*[data-required=\"true\"] input, *[data-required=\"true\"] textarea").forEach(function ($field) {
                var type = $field.getAttribute("type");
                var value = $field.value;
                var name = $field.getAttribute("name");
                if (type === "text" && !value) tmpErrorObj[name] = true;
                if (type === "email" && !value) tmpErrorObj[name] = true;
                if (type === "file" && !value) tmpErrorObj[name] = true;
                if (type === "password" && !value) tmpErrorObj[name] = true;
                if (type === "checkbox" && !$field.checked) tmpErrorObj[name] = true;
                if (!type && !value) tmpErrorObj[name] = true; // textarea or input select
              }); // has form fields

              if ((0, _isEmpty.default)(tmpErrorObj)) {
                _context.next = 7;
                break;
              }

              setFormConfig(_objectSpread(_objectSpread({}, formConfig), {}, {
                errorFields: tmpErrorObj
              }));
              return _context.abrupt("return");

            case 7:
              // no errors -> lock form
              setFormConfig(_objectSpread(_objectSpread({}, formConfig), {}, {
                formLocked: true,
                errorFields: tmpErrorObj
              }));
              formSendDate.current = new Date();

              if (!(recaptchaRef !== null && recaptchaRef !== void 0 && recaptchaRef.current)) {
                _context.next = 15;
                break;
              }

              _context.next = 12;
              return recaptchaRef.current.executeAsync();

            case 12:
              submitForm($form);
              _context.next = 16;
              break;

            case 15:
              submitForm($form);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleFormCheck(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  var submitForm = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2($form) {
      var formData, action, sendData, object, loginToken, formDataString, response, _response, _response2;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              formData = new FormData($form);
              action = $form.getAttribute("action");
              sendData = null;

              if (config === undefined) {
                config = {};
              }

              if (config.headers === undefined) {
                config.headers = {};
              }

              if (contentType === "formData") {
                sendData = formData;
              } else if (contentType === "json" || "JSON") {
                object = {};
                formData.forEach(function (value, key) {
                  return object[key] = value;
                });
                sendData = JSON.stringify(object);
                config.headers["Content-Type"] = "application/json";
              }

              if (authorization) {
                loginToken = localStorage.getItem("logintoken");

                if (loginToken) {
                  config.headers["Authorization"] = "Bearer ".concat(loginToken);
                }
              }

              _context2.t0 = method;
              _context2.next = _context2.t0 === "GET" ? 10 : _context2.t0 === "get" ? 10 : _context2.t0 === "CUSTOM" ? 16 : _context2.t0 === "custom" ? 16 : _context2.t0 === "PUT" ? 18 : _context2.t0 === "put" ? 18 : _context2.t0 === "DELETE" ? 24 : _context2.t0 === "delete" ? 24 : _context2.t0 === "POST" ? 30 : _context2.t0 === "post" ? 30 : 30;
              break;

            case 10:
              formDataString = new URLSearchParams(sendData).toString();

              if (!absoluteUrl) {
                _context2.next = 14;
                break;
              }

              window.location.href = "".concat(action, "?").concat(formDataString);
              return _context2.abrupt("return");

            case 14:
              navigate("".concat(action, "?").concat(formDataString));
              return _context2.abrupt("break", 36);

            case 16:
              onSubmit(sendData);
              return _context2.abrupt("break", 36);

            case 18:
              _context2.next = 20;
              return _axios.default.put(action, sendData, config);

            case 20:
              response = _context2.sent;
              setServerResponse(response);
              if (onAfterSubmit) onAfterSubmit(response);
              return _context2.abrupt("break", 36);

            case 24:
              _context2.next = 26;
              return _axios.default.delete(action, sendData, config);

            case 26:
              _response = _context2.sent;
              setServerResponse(_response);
              if (onAfterSubmit) onAfterSubmit(_response);
              return _context2.abrupt("break", 36);

            case 30:
              _context2.next = 32;
              return _axios.default.post(action, sendData, config);

            case 32:
              _response2 = _context2.sent;
              setServerResponse(_response2);
              if (onAfterSubmit) onAfterSubmit(_response2);
              return _context2.abrupt("break", 36);

            case 36:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function submitForm(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement("form", _extends({
    className: (0, _clsx.default)(css.form, "mco-form"),
    ref: formRef,
    onChange: function onChange() {
      if (typeof _onChange === "function") {
        var formData = new FormData(formRef === null || formRef === void 0 ? void 0 : formRef.current);

        _onChange(formData);
      }
    },
    onSubmit: handleFormCheck
  }, formProps), /*#__PURE__*/_react.default.createElement(_formContext.default.Provider, {
    value: [formConfig, setFormConfig]
  }, props.children));
};

var _default = Form;
exports.default = _default;